import { Images } from '@/assets/images';
import { cn } from '@/utils';
import { memo } from 'react';

const PrintButton = ({
	onPrint,
	className,
}: {
	onPrint?: () => void;
	className?: string;
}) => {
	return (
		<div
			className={cn(
				'absolute right-10 top-1/2 -translate-y-1/2 cursor-pointer',
				className
			)}
			onClick={onPrint}
		>
			<img src={Images.iconPrint} alt="print" />
		</div>
	);
};
export default memo(PrintButton);
